import { useEffect } from "react";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useShop } from "@/context/Shop";
import { useSeo } from "@/hooks/useSeo";

const NAV = [
  ["", "Overview", "account-nav-overview"],
  ["profile", "Profile", "account-nav-profile"],
  ["addresses", "Addresses", "account-nav-addresses"],
  ["orders", "Orders", "account-nav-orders"],
  ["consents", "Marketing & privacy", "account-nav-consents"],
  ["security", "Security", "account-nav-security"],
];

export default function AccountLayout() {
  const { customer, authLoading, logout } = useShop();
  const navigate = useNavigate();
  const loc = useLocation();
  useSeo("My account", "Manage your Maison Éclat account.");
  useEffect(() => {
    if (!authLoading && !customer) navigate("/account/login", { replace: true, state: { from: loc.pathname } });
  }, [authLoading, customer, navigate, loc.pathname]);
  if (authLoading || !customer) return <div className="container-lux py-24"><p className="text-sm text-muted-foreground">Loading your account…</p></div>;
  return (
    <div className="container-lux pt-8 pb-20" data-testid="account-layout">
      <nav className="text-xs text-muted-foreground mb-6"><Link to="/" className="hover:text-foreground">Home</Link><span className="mx-1.5">/</span><span className="text-foreground">My account</span></nav>
      <header className="mb-10"><p className="eyebrow">Welcome</p><h1 className="font-display text-5xl font-medium mt-1">{customer.first_name}</h1></header>
      <div className="grid lg:grid-cols-12 lg:gap-14">
        <aside className="lg:col-span-3" aria-label="Account menu">
          <nav className="flex lg:flex-col gap-1 overflow-x-auto lg:overflow-visible scrollbar-none pb-2 lg:pb-0 lg:sticky lg:top-28" data-testid="account-nav">
            {NAV.map(([to, label, id]) => (
              <NavLink key={to || "home"} end={to === ""} to={to} data-testid={id}
                className={({ isActive }) => `whitespace-nowrap rounded-md px-4 py-2.5 text-sm transition-colors ${isActive ? "bg-foreground text-background" : "text-foreground/80 hover:bg-secondary"}`}>
                {label}
              </NavLink>
            ))}
            <button onClick={async () => { await logout(); navigate("/"); }} className="whitespace-nowrap rounded-md px-4 py-2.5 text-sm text-left text-foreground/80 hover:bg-secondary mt-2 lg:mt-6 border-t pt-5" data-testid="account-logout-button">Sign out</button>
          </nav>
        </aside>
        <section className="lg:col-span-9 mt-6 lg:mt-0"><Outlet /></section>
      </div>
    </div>
  );
}
